import { TipoRelatorio } from "enums/tipo-relatorio";
import { Observable } from "rxjs";

export abstract class AbReport {
  abstract delay(): Promise<any>;
  abstract relatorioS3(tipoRelatorio: TipoRelatorio, tentativa: number): void;
  abstract verificaRota(tipoRelatorio: TipoRelatorio): any;
  abstract gerarRelatorio(consulta: Observable<any>, tipoRelatorio: TipoRelatorio)
  abstract verificarRelatorioS3(error: any): boolean;
  abstract isFailureResponse(error: any): boolean;
  abstract showProgressSpinner();
  abstract hideProgressSpinner();
}